/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals Drupal: true, site: true, TimelineMax: true, TweenMax: true, Power4: true, ScrollMagic: true, page_data: true, YT: true, Expo: true, Spinner: True, jQuery: true */

(function ($) {
  'use strict';

  Drupal.behaviors.ModuleHoliday2017 = {
    attach: function (context, settings) {
      // DOM
      var $window = $(window);
      var $boutique = $('#holiday-2017_container', context);
      // LOGIC
      var debug = false;
      var mobileSize = 640;
      var isMobile;
      var isDesktop;
      var isIpad;
      var ieVersion;
      var youtubeAPIReady = false;
      // BEGIN: Deeplink Helpers
      var deeplinkHelper = {
        get: function (seperator) {
          var hashRaw = window.location.hash.trim().replace(/^#{1}/, '');
          var hashData;

          if (hashRaw.length === 0) {
            return [];
          }

          hashData = hashRaw.split(typeof seperator !== 'string' || seperator.length === 0 ? '/' : seperator);

          hashData = hashData.filter(function (element) {
            return element.trim().length !== 0;
          });

          return hashData;
        },
        set: function (value) {
          var hashString = '';
          var hashValue;
          var h = 0;

          if (typeof value === 'string' || typeof value === 'number') {
            window.location.replace('#/' + value);
          } else if (typeof value === 'object' && value instanceof Array) {
            for (h = 0; h < value.length; h++) {
              hashValue = value[h];

              if (typeof hashValue === 'string' || typeof hashValue === 'number') {
                hashString += (hashString.length === 0 ? '' : '\/') + hashValue;
              }
            }

            window.location.replace('#/' + hashString);
          }
        }
      };
      // END: Deeplink Helpers

      // BEGIN: Platform Checks
      (function () {
        /*
        * @function getInternetExplorerVersion
        * @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
        * @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
        * @returns {Number} -1 if not any IE version, any other number otherwise
        */
        function getInternetExplorerVersion() {
          var rv = -1;
          var ua;
          var re;

          // works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
          if (navigator.appName === 'Microsoft Internet Explorer') {
            ua = navigator.userAgent;
            re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');

            if (re.exec(ua) !== null) {
              rv = parseFloat(RegExp.$1);
            }
          } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Trident') > -1) {
            rv = 11;
          }

          return rv;
        }

        // BEGIN: Platform checks
        {
          // Initial mobile checks (additional checks will be needed for 'desktop mobile' sizes)
          isMobile = typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
          isDesktop = !isMobile;
          isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;
          ieVersion = getInternetExplorerVersion();

          if (ieVersion !== -1) {
            $boutique.addClass('ie ie-' + ieVersion);
          }

          if (isDesktop) {
            isMobile = $(window).width() <= mobileSize;

            if (isMobile) {
              $boutique.addClass('mobile');
            }
          }

          // set classes for desktop/mobile/ipad/ie
          if (isIpad) {
            $boutique.addClass('ipad desktop');
          } else {
            $boutique.addClass(isMobile ? 'mobile' : 'desktop');
          }
        }
        // END: Platform checks

        // BEGIN: Events
        {
          // Resize handler that should trigger resize handling with a delay after a resize
          var resizeHandler = (function () {
            var resizeTimeout;

            return function () {
              // Do not allow resizeTimeout creation until timer run and resizeTimeout is undefined again
              if (typeof resizeTimeout !== 'undefined') {
                return;
              }

              resizeTimeout = window.setTimeout(function () {
                /*
                   Required for section load, unload, and update functions called by this function
                   There may be additional animations and functionality implemented in those functions that need to be called.
                   Calling this after resize insures that sections "now" in view get updated while sections that are "now" out of view are unloaded
                */
                // Add mobile class if desktop class scales under mobile size
                if (isDesktop) {
                  if ($window.width() <= mobileSize && !$boutique.hasClass('mobile')) {
                    if (debug) {
                      console.log('resizeHandler: Desktop gained mobile');
                    }

                    $boutique.addClass('mobile');
                    $boutique.removeClass('desktop');

                    isMobile = true;
                    $window.trigger('desktopGainedMobile');
                  } else if ($window.width() > mobileSize && $boutique.hasClass('mobile')) {
                    if (debug) {
                      console.log('resizeHandler: Desktop lost mobile');
                    }

                    $boutique.removeClass('mobile');
                    $boutique.addClass('desktop');
                    isMobile = false;
                    $window.trigger('desktopLostMobile');
                  }
                }

                // Clear timeout for re-creation
                resizeTimeout = undefined;
              }, 500);
            };
          })();

          $window.on('resize', resizeHandler).trigger('resize');
        }
        // END: Events
      })();
      // END: Platform checks

      // BEGIN: Holiday 2017 Landing
      (function () {
        // DOM
        var $deeplinkTarget;
        // LOGIC
        var deeplinkData = deeplinkHelper.get();

        // Landing functionality only
        if (!$boutique.hasClass('landing')) {
          return;
        }

        // BEGIN: INIT
        {
          $deeplinkTarget = $boutique.find('#holiday-2017_tile-' + deeplinkData[0]);

          // If mobile look for element in carousel
          if (isMobile) {
            if (deeplinkData.length > 1 && $deeplinkTarget.find('.carousel').length !== 0) {
              $deeplinkTarget = $deeplinkTarget.find('.carousel').children().eq(deeplinkData[1]);
            }
          }
        }
        // END: INIT

        // BEGIN: Background Circles
        (function () {
          // DOM
          var $backgroundCircles = $boutique.find('#holiday-background .circle');

          // BEGIN: Init
          {
            $backgroundCircles.each(function () {
              // DOM
              var $this = $(this);
              var $circle = $this;
              var $sparkle = $this.find('.sparkle');
              // LOGIC
              var increment = 360 / $sparkle.length;
              var current = 0;

              $sparkle.each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var radius = $circle.width() / 2;
                var distance = Math.random() * radius * 0.55 + radius * 0.4;
                var angle = increment * current * Math.PI / 180;

                TweenMax.set($this, {
                  x: radius + distance * Math.cos(angle),
                  y: radius + distance * Math.sin(angle)
                });

                TweenMax.fromTo($this.find('img'), 1.5 + 0.5 * Math.random(), {
                  scale: 0.2,
                  opacity: 0
                }, {
                  scale: 0.5 + (0.25 * Math.random()),
                  opacity: 1,
                  repeat: -1,
                  ease: Power4.easeIn,
                  yoyo: true,
                  delay: current
                });

                current++;
              });
            });
          }
          // END: Init

          // BEGIN: Events
          {
            $window.on('postLoad', function () {
              // Disable parallax on iPad for performance reasons
              if (!isIpad) {
                $window.on('scroll', function () {
                  // LOGIC
                  var scrollTop = $window.scrollTop();

                  $backgroundCircles.each(function () {
                    // DOM
                    var $this = $(this);
                    // LOGIC
                    var windowHeight = $window.height();
                    // Partially or in view immediately
                    var offset = $this.offset().top < $window.height() ? $this.offset().top - windowHeight : 0;
                    var speed = $this.data('speed');
                    var modifier = 1;
                    var progress;

                    progress = -($this.offset().top - windowHeight - scrollTop - offset) / ($this.height() - offset + windowHeight);

                    if (speed === 'fast') {
                      modifier = 3;
                    }

                    if (speed === 'slow') {
                      modifier = 0.5;
                    }

                    progress = progress > 1 ? 1 : progress < 0 ? 0 : progress;

                    TweenMax.set($this.find('.base, .sparkle-container'), { y: -100 * modifier * progress + '%' });
                  });
                }).trigger('scroll');
              }
            });
          }
          // END: Events
        })();
        // END: Background Circles

        // BEGIN: Tile Handling
        (function () {
          // DOM
          var $tiles = $boutique.find('.tile');
          var $videoModal = $boutique.find('.holiday-overlay');
          var $videoTarget = $videoModal.find('#video_1');
          var $mouseSparkle = $boutique.find('.mouse-sparkle'); // Target image to clone for drawing
          var $pageHeader = $('.page-header');
          // LOGIC
          var fps = 30;
          var controller = new ScrollMagic.Controller();
          var particles = {};
          var particleUpdateInterval;
          var particleRenderInterval; // Fallback for IE 9
          var particlesShouldRender = true;

          // Updates the youtube modal's scrubber based on current player progress
          function youtubeUpdateHandler() {
            var player = $videoModal.data('player');
            var duration;
            var currentTime;
            var progress;

            if (typeof player === 'undefined') {
              return;
            }

            duration = player.getDuration();
            currentTime = player.getCurrentTime();
            progress = currentTime / duration;

            $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
          }

          // Spawns particles for a given canvas
          function spawnParticle($canvas, x, y, particlesToSpawn) {
            // LOGIC
            var rotation;
            var anglePosition;
            var baseLifetime = 3000;
            var lifetimeVariance = 1000;
            var lifetime = baseLifetime - (lifetimeVariance * Math.random());
            var startDistance = 10 * Math.random();
            var p = 0;

            if ($canvas.length === 0) {
              return;
            }

            for (p = 0; p < particlesToSpawn; p++) {
              rotation = 360 * Math.random(); // Starting rotation
              anglePosition = 360 * Math.random() * Math.PI / 180;
              particles['p' + Date.now() + p] = {
                canvas: $canvas,
                image: $mouseSparkle[0],
                velocity: {
                  x: 2 * Math.cos(rotation * Math.PI / 180),
                  y: 2 * Math.sin(rotation * Math.PI / 180)
                },
                position: {
                  x: x + startDistance * Math.cos(anglePosition),
                  y: y + startDistance * Math.sin(anglePosition)
                },
                rotation: rotation,
                rotationDir: Math.random() >= 0.5 ? 1 : -1,
                endTime: Date.now() + lifetime,
                scale: 1 - 0.8 * Math.random(),
                opacity: 1 - 0.4 * Math.random(),
                lifetime: lifetime
              };
            }
          }

          // Updates particles in particles
          function particleUpdate() {
            var prop;
            var particle;
            var currentTime = Date.now();
            var progress;

            // Update each particle
            for (prop in particles) {
              if (particles.hasOwnProperty(prop)) {
                particle = particles[prop];
                progress = (particle.endTime - currentTime) / particle.lifetime;
                progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;

                // Lower scale
                particle.scale *= progress;

                // Update position
                particle.position.x += particle.velocity.x;
                particle.position.y += particle.velocity.y;

                // Update rotation
                particle.rotation += particle.rotationDir;

                // Lower velocity
                particle.velocity.x -= particle.velocity.x * 0.05;
                particle.velocity.y -= particle.velocity.y * 0.05;

                if (currentTime >= particle.endTime) {
                  delete particles[prop];
                }
              }
            }
          }

          // Renders particles in particles
          function particleRender() {
            // DOM
            var $canvas;
            var image;
            // LOGIC
            var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
            var prop;
            var particle;
            var context;
            var position;
            var currentTime = Date.now();
            var progress;

            if (!particlesShouldRender) {
              return;
            }

            // Clear each canvas
            $boutique.find('canvas').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var context = $this.data('context');

              if (typeof context === 'undefined') {
                return;
              }

              context.clearRect(0, 0, context.canvas.width, context.canvas.height);
            });

            // Draw each particle
            for (prop in particles) {
              if (particles.hasOwnProperty(prop)) {
                particle = particles[prop];
                $canvas = particle.canvas;
                context = $canvas.data('context');
                image = particle.image;
                position = particle.position;
                progress = (particle.endTime - currentTime) / particle.lifetime;
                progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;

                if (typeof context === 'undefined') {
                  return;
                }

                context.globalAlpha = particle.opacity * progress;
                context.translate(position.x, position.y);
                context.scale(particle.scale, particle.scale);
                context.rotate(particle.rotation * Math.PI / 180);
                context.drawImage(image, -image.width / 2, -image.height / 2);
                context.setTransform(1, 0, 0, 1, 0, 0);
                context.globalAlpha = 1;
              }
            }

            if (typeof requestAnimationFrame === 'function') {
              requestAnimationFrame(particleRender);
            }
          }

          // Starts logic and rendering
          function startParticleUpdate() {
            var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

            particleUpdateInterval = window.setInterval(particleUpdate, 1000 / fps);

            particlesShouldRender = true;

            // Use request animation frame if available, otherwise fallback to interval
            if (typeof requestAnimationFrame === 'function') {
              requestAnimationFrame(particleRender);
            } else {
              particleRenderInterval(particleRender(), 1000 / fps);
            }
          }

          // Stops logic and rendering
          function stopParticleUpdate() {
            if (typeof particleUpdateInterval !== 'undefined') {
              window.clearInterval(particleUpdateInterval);
              particleUpdateInterval = undefined;
            }

            if (typeof particleRenderInterval !== 'undefined') {
              window.clearInterval(particleRenderInterval);
              particleRenderInterval = undefined;
            }

            particlesShouldRender = false;
          }

          // BEGIN: INIT
          {
            // Tiles include slides on mobile
            if (isMobile) {
              $tiles = $tiles.add($tiles.find('.slide'));
            }

            // Do not allow scrollMagic updates
            controller.enabled(false);

            // Set tile opacity for initial animation
            $tiles.css({ opacity: 0 });

            // BEGIN: Carousel Tiles
            $tiles.each(function () {
              // DOM
              var $this = $(this);
              var $headerContainer = $this.find('.holiday-header');
              var $carousel = $this.find('.carousel');
              var $slides = $carousel.children();
              var $prev = $this.find('.left a');
              var $next = $this.find('.right a');
              var $headersDesktop = $this.find('.holiday-header div');
              // LOGIC
              var animation = new TimelineMax({ paused: true });
              var carouselAutoScrollInterval;
              var carouselAutoScrollRate = 5;
              var carouselAutoScrollTimeout;
              var blurred = false;
              var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 'onCenter',
                duration: function () {
                  return $this.height();
                }
              });

              // Clears auto-progression timers
              function stopAutoProgression() {
                if (typeof carouselAutoScrollInterval !== 'undefined') {
                  window.clearInterval(carouselAutoScrollInterval);
                }

                if (typeof carouselAutoScrollTimeout !== 'undefined') {
                  window.clearTimeout(carouselAutoScrollTimeout);
                }
              }

              // Starts auto-progression timers
              function startAutoProgression(delay) {
                if (typeof delay !== 'number') {
                  delay = carouselAutoScrollRate;
                }

                // Clear existing timers before starting to prevent overlap
                stopAutoProgression();

                carouselAutoScrollTimeout = window.setTimeout(function () {
                  carouselAutoScrollInterval = window.setInterval(function () {
                    $carousel.carouselNext();
                  }, carouselAutoScrollRate * 1000);
                }, delay * 1000);
              }

              // Must have a carousel classed element
              if ($this.find('.carousel').length === 0) {
                return;
              } else {
                $this.addClass('has-carousel');
              }

              // BEGIN: Init
              {
                // No carousel functionality on mobile
                if (isMobile) {
                  $this.css({ opacity: 1 });
                } else {
                  $carousel.el_carousel({
                    debug: debug,
                    increment: '100%',
                    offset: '0%',
                    useGSAP: true,
                    duration: 1.5
                  });

                  // Build intro animation

                  $window.on('postLoad', function () {
                    // Desktop only functionality
                    // And IE versions greater than 9
                    if (!isMobile && !isIpad && (ieVersion === -1 || ieVersion > 9)) {
                      startParticleUpdate();
                    }

                    TweenMax.set($this.find('.holiday-header li').not(':first-child'), { opacity: 0 });

                    animation
                      .set($this, { opacity: 1 })
                      .fromTo($slides.first(), 0.8, {
                        x: '100%',
                        opacity: 0
                      }, {
                        x: '0%',
                        opacity: 1
                      })
                      .staggerFromTo($headersDesktop, 0.6, {
                        y: '-100%',
                        opacity: 0
                      }, {
                        y: '0%',
                        opacity: 1
                      }, 0.2, '-=0.75')
                      .set($this, { className: '+=ready' })
                      .add(function () {
                        $this.trigger('tileReady');
                      });

                    // Set animation to start via scrollMagic
                    scene
                      .addTo(controller)
                      // Scene only triggers once
                      .on('start', function () {
                        // Play animation once
                        if (!$this.hasClass('ready') && !animation.isActive()) {
                          animation.play();
                        }
                      })
                      .on('enter', function () {
                        deeplinkHelper.set($this.index());

                        // Assumes animation has already complete. Start tile auto progression
                        if ($this.hasClass('ready')) {
                          startAutoProgression();
                        }
                      })
                      .on('leave', function () {
                        stopAutoProgression();
                      });
                  });
                }
              }
              // END: Init

              // BEGIN: Events
              {
                // Start autoscroll when the tile is completely visible
                $this.one('tileReady', function () {
                  // Do not start progression if window is not in focus
                  if (blurred === true) {
                    return;
                  }

                  // Start auto progression once intro animation completes
                  startAutoProgression(0);
                });

                // Prev button progression
                $prev.on('click', function (e) {
                  e.preventDefault();

                  $carousel.carouselPrev();

                  // Stop auto progression
                  stopAutoProgression();

                  // Resume auto progression after a set time
                  startAutoProgression();
                });

                // Next button progression
                $next.on('click', function (e) {
                  e.preventDefault();

                  $carousel.carouselNext();

                  // Stop auto progression
                  stopAutoProgression();

                  // Resume auto progression after a set time
                  startAutoProgression();
                });

                // Key press progress
                $window
                  .on('keydown', function (e) {
                    var key = e.which;

                    switch (key) {
                      // Left arrow key
                      case 37:
                        $prev.trigger('click');
                        break;

                      // Right arrow Key
                      case 39:
                        $next.trigger('click');
                        break;
                    }
                  })
                  .on('desktopGainedMobile', function () {
                    $carousel.elCarouselDestroy();
                    $carousel.find('.slide').attr('style', '');
                    $headerContainer.find('li').attr('style', '');
                  })
                  .on('desktopLostMobile', function () {
                    if (!isMobile) {
                      $carousel.el_carousel({
                        debug: debug,
                        increment: '100%',
                        offset: '0%',
                        useGSAP: true,
                        duration: 1.5
                      });
                    }
                  })
                  // Stop auto progression when tab/window loses focus
                  .on('blur', function () {
                    if (!$this.hasClass('ready')) {
                      return;
                    }

                    blurred = true;

                    // Stop auto progression
                    stopAutoProgression();
                  })
                  // Resume auto progression when tab/window regains focus
                  .on('focus', function () {
                    if (!$this.hasClass('ready')) {
                      return;
                    }

                    blurred = false;

                    // Ensure no timer overlap
                    stopAutoProgression();

                    // Resume auto progression after a set time
                    startAutoProgression();
                  });

                // Swipe controls for carousel progression
                $carousel
                  .swipe({
                    swipeLeft: function () {
                      $next.trigger('click');
                    },
                    swipeRight: function () {
                      $prev.trigger('click');
                    },
                    threshold: 100
                  })
                  .on('mouseenter', function () {
                    stopAutoProgression();
                  })
                  .on('mouseleave', function () {
                    startAutoProgression();
                  });

                $carousel.children().on('slideWillLoseActive', function () {
                  // LOGIC
                  var animation = new TimelineMax();

                  animation
                    .to($headerContainer.children(), 0.5, { opacity: 0 });
                }).on('slideWillGainActive', function () {
                  // DOM
                  var $this = $(this);
                  var $header;
                  // LOGIC
                  var index = $this.index();
                  var animation = new TimelineMax();

                  $header = $headerContainer.children().eq(index);

                  animation
                    .set($header, { className: '+=active' })
                    .fromTo($header, 0.5, { opacity: 0 }, { opacity: 1 });
                }).on('slideHasGainedActive', function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var index = $this.index();

                  $('.carousel_pagination li').eq(index).addClass('active').siblings().removeClass('active');
                });

                // Dot nav handling
                $('.carousel_pagination li').on('click', function (e) {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var index = $this.index();
                  var prevIndex = $('.carousel_pagination li.active').index();

                  e.preventDefault();

                  if (index === prevIndex) {
                    return;
                  }

                  $this.addClass('active').siblings().removeClass('active');

                  startAutoProgression();

                  $carousel.carouselTo(index);
                }).first().addClass('active');
              }
              // END: Events
            });
            // END: Carousel Tiles

            // BEGIN: Normal Tiles
            $window.on('postLoad', function () {
              $tiles.each(function () {
                // DOM
                var $this = $(this);
                var $headersDesktop = $this.find('.holiday-header div');
                var $headersMobile = $this.find('.holiday-product_mobile div, .holiday-header div, p.eyebrow');
                // LOGIC
                var scene = new ScrollMagic.Scene({
                  triggerElement: this,
                  triggerHook: 'onCenter',
                  offset: $this.is('.last') ? -$this.height() : 0,
                  duration: function () {
                    return $this.height();
                  }
                });
                var animation = new TimelineMax({ paused: true });

                // Do not process tiles that have a carousel as a parent if not in mobile mode
                if (!isMobile) {
                  if ($this.closest('.carousel').length !== 0) {
                    $this.css({ opacity: 1 });

                    return;
                  }
                }

                // Must not have a carousel element
                if ($this.find('.carousel').length !== 0) {
                  return;
                }

                animation
                  .set($this, { opacity: 1 })
                  .fromTo(
                    $this.find('.holiday-image img'),
                    0.6,
                    {
                      opacity: 0,
                      y: '10%'
                    },
                    {
                      opacity: 1,
                      y: '0%'
                    }
                  );

                // Tile header animation desktop and mobile have different targets
                if (isMobile) {
                  animation
                    .staggerFromTo($headersMobile, 0.6, {
                      y: '-100%',
                      opacity: 0
                    }, {
                      y: '0%',
                      opacity: 1
                    }, 0.2);
                } else if (!isMobile && $headersDesktop.length !== 0) {
                  animation
                    .staggerFromTo($headersDesktop, 0.6, {
                      y: '-100%',
                      opacity: 0
                    }, {
                      y: '0%',
                      opacity: 1
                    }, 0.2, '-=0.75');
                }

                // Mark tile as ready
                animation
                  .set($this, { className: '+=ready' })
                  .add(function () {
                    $this.trigger('tileReady');
                    scene.removeTween();
                  });

                // Set animation to start via scrollMagic
                scene
                  .addTo(controller)
                  .on('start', function () {
                    animation.play();
                  })
                  .on('enter', function () {
                    var $carouselParent = $this.closest('.carousel').closest('.tile');

                    if (isMobile && $carouselParent.length !== 0) {
                      deeplinkHelper.set([$carouselParent.index(), $this.index()]);
                    }
                    // Desktop and otherwise, normal deeplinking
                    else {
                      deeplinkHelper.set($this.index());
                    }
                  });
              });

              $tiles.add($boutique.find('.slide')).each(function () {
                // DOM
                var $this = $(this);

                // Initialize Canvas
                (function () {
                  // DOM
                  var $canvas = $this.find('canvas');
                  var canvas = $canvas[0];
                  // LOGIC
                  var context;

                  if ($canvas.length === 0) {
                    return;
                  }

                  context = canvas.getContext('2d');

                  context.canvas.width = $canvas.width();
                  context.canvas.height = $canvas.height();

                  $canvas.data('context', context);
                })();
              });

              controller.enabled(true).update(true);

              if (deeplinkData.length !== 0) {
                TweenMax.to($window, 1, {
                  scrollTo: {
                    y: $deeplinkTarget.offset().top - ($pageHeader.length !== 0 ? $pageHeader.height() : 0),
                    autoKill: false
                  }
                });
              }
            });
            // END: Normal Tiles

            // BEGIN: Product Tile Setup
            (function () {
              $boutique.find('.holiday-image > a').each(function () {
                // DOM
                var $this = $(this);
                var $priceField = $this.find('.el-product_price');
                // LOGIC
                var type = $this.data('type');
                var useML = $this.data('use-ml');
                var productID = $this.data('product');
                var productData;
                var productProperty;
                var p = 0;
                var skuData;
                var unitPrice;
                var price;
                var measurement;

                productID = typeof productID === 'undefined' ? undefined : productID.trim().length === 0 ? undefined : productID;

                // Must have a valid product ID
                if (typeof productID === 'undefined') {
                  return;
                }

                // Must be an add-to-bag or quickshop
                if (typeof type !== 'undefined' && !(type === 'add-to-bag' || type === 'quickshop')) {
                  return;
                }

                // Look for product with product ID in page data
                // If page_data is undefined, immediately stop doing anything
                if (typeof page_data === 'undefined') {
                  return false;
                } else {
                  for (productProperty in page_data) {
                    if (page_data.hasOwnProperty(productProperty)) {
                      // Must have product property
                      if (typeof page_data[productProperty].products === 'undefined') {
                        return;
                      } else {
                        for (p = 0; p < page_data[productProperty].products.length; p++) {
                          productData = page_data[productProperty].products[p];
                          if (productData.PRODUCT_ID === productID) {
                            skuData = productData.skus[0];
                            unitPrice = skuData.formattedUnitPrice;
                            price = skuData.formattedPrice;
                            measurement = skuData.PRODUCT_SIZE;

                            $this.data('product_data', productData);

                            if (typeof useML !== 'undefined') {
                              // Must have all fields to replace price
                              if (typeof unitPrice === 'string' && unitPrice.trim().length !== 0 && typeof price === 'string' && price.trim().length !== 0 && typeof measurement === 'string' && measurement.trim().length !== 0) {
                                $priceField.html('<span class="size">' + measurement + '</span> <span class="price">' + price + '</span><br /><span ="unit-price">' + unitPrice + '</span>');
                              } else if (typeof price !== 'undefined') {
                                $priceField.html(price);
                              }
                            } else if (typeof price !== 'undefined') {
                              $priceField.html(price);
                            }

                            return;
                          }
                        }
                      }
                    }
                  }
                }
              });
            })();
            // END: Product Tile Setup
          }
          // END: INIT

          // BEGIN: EVENTS
          {
            // Inject video into respective tiles for mobile only once the API is ready
            $window
              .on('youtubeReady', function () {
                if (!isMobile || !youtubeAPIReady) {
                  return;
                }

                // Look through each tile and slide for
                $tiles.find('.holiday-image > a').each(function () {
                  // DOM
                  var $this = $(this);
                  var $videoTarget = $this.find('.mobile-video-target');
                  var $closeButton = $this.find('.close_btn');
                  // LOGIC
                  var type = $this.data('type');
                  var youtubeId = $this.data('youtube-id');
                  var youtubePlayer;

                  // Must have the video element
                  if ($videoTarget.length === 0 || $this.hasClass('youtube-ready') || type !== 'video') {
                    return;
                  }

                  youtubePlayer = new YT.Player($videoTarget[0], {
                    videoId: youtubeId,
                    playerVars: {
                      autoplay: 0,
                      cc_load_policy: 0,
                      iv_load_policy: 1,
                      color: 'red',
                      controls: 1,
                      html5: 1,
                      playsinline: 1,
                      rel: 0,
                      modestbranding: 1,
                      showinfo: 1,
                      wmode: 'transparent',
                      enablejsapi: 1
                    },
                    events: {
                      'onReady': function () {
                        $this.addClass('youtube-ready');
                      },
                      'onStateChange': function (e) {
                        var state = e.data;

                        // Unstarted/Play/Buffering
                        // Reveal video
                        if (state === -1 || state === 1 || state === 3) {
                          TweenMax.to([$videoTarget, $closeButton], 1, {
                            opacity: 1,
                            display: 'block'
                          });
                        }
                        // Ended
                        // Hide video
                        else if (state === 0) {
                          TweenMax.to($videoTarget, 1, {
                            opacity: 0,
                            display: 'none'
                          });
                        }
                      }
                    }
                  });

                  $this.data('player', youtubePlayer);
                })
                // Click event resumes video on container touch
                  .on('click', function (e) {
                    // DOM
                    var $this = $(this);
                    // LOGIC
                    var player = $this.data('player');

                    // Ignore close button clicks and player must be defined
                    if (typeof player === 'undefined') {
                      return;
                    }

                    e.preventDefault();
                    TweenMax.to($this.find('.mobile-video-target'), 1, {
                      opacity: 1,
                      display: 'block'
                    });
                    player.playVideo();
                  });
              })
              .on('keydown', function (e) {
                // Close open videos and modals
                if (e.which === 27) {
                  $videoModal.filter('.active').find('.close_btn').trigger('click');
                }
              })
              // Update canvases
              .on('resize canvasUpdate', function () {
                // DOM
                var $canvas = $boutique.find('canvas');

                $canvas.each(function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var context = $this.data('context');

                  if (typeof context === 'undefined') {
                    return;
                  }

                  context.canvas.width = $this.width();
                  context.canvas.height = $this.height();
                });
              })
              .on('touchstart', function (e) {
                // If tile and its contents have been touched do not do anything
                if ($(e.target).closest('.tile, .slide').length !== 0) {
                  return;
                }

                // Hide hoverstates for all tiles
                $tiles.not('.has-carousel').add($boutique.find('.slide')).trigger('mouseleave');
              });

            // Desktop video functionality
            $boutique.find('.holiday-image > a').on('click', function (e, override) {
              // DOM
              var $this = $(this);
              var $target;
              // LOGIC
              var type = $this.data('type');
              var productData = $this.data('product_data');
              var youtubeId = $this.data('youtube-id');
              var youtubePlayer;
              var content = $this.data('target-selector'); // Target ID?
              var revealed = $this.closest('.revealed').length !== 0;

              // Use native <a> tag functionality
              if (typeof type === 'undefined' || type.trim().length === 0) {
                // Hoverstate must be revealed before allowing link to target page
                // Override skips this check
                if ((typeof override === 'undefined' && isIpad && !revealed) || (typeof override === 'boolean' && override === false)) {
                  e.preventDefault();
                }

                return;
              }

              e.preventDefault();

              // Hover state must be fully revealed before further action
              // Override skips this check
              if ((typeof override === 'undefined' && !revealed && isIpad) || (typeof override === 'boolean' && override === false)) {
                return;
              }

              // Process data
              youtubeId = typeof youtubeId === 'undefined' ? undefined : youtubeId.trim().length === 0 ? undefined : youtubeId;

              switch (type) {
                case 'add-to-bag':
                  if (typeof productData === 'undefined') {
                    return;
                  }

                  site.addToCart({
                    skuData: {
                      SKU_BASE_ID: productData.skus[0].SKU_ID.replace(/[A-z]+/, ''),
                      PARENT_CAT_ID: productData.PRODUCT_ID
                    },
                    quantity: 1,
                    QTY: 1
                  });

                  break;

                case 'quickshop':
                  if (typeof productData === 'undefined') {
                    return;
                  }

                  site.quickshop(productData);

                  break;

                case 'video':
                  // Must have a youtube ID and video modal functionality won't exist in mobile
                  if (typeof youtubeId === 'undefined' || !isDesktop || !youtubeAPIReady) {
                    return;
                  }

                  // Destroy existing players
                  if (typeof $videoModal.data('player') !== 'undefined') {
                    $videoModal.data('player').destroy();
                    $videoModal.removeData('player');
                  }

                  $videoModal.addClass('active');

                  youtubePlayer = new YT.Player($videoTarget[0], {
                    videoId: youtubeId,
                    playerVars: {
                      autoplay: 1,
                      cc_load_policy: 0,
                      iv_load_policy: 1,
                      color: 'red',
                      controls: 0,
                      html5: 1,
                      playsinline: 1,
                      rel: 0,
                      modestbranding: 1,
                      showinfo: 1,
                      wmode: 'transparent',
                      enablejsapi: 1
                    },
                    events: {
                      'onStateChange': function (e) {
                        var state = e.data;

                        // Playing/Buffering
                        if (state === -1 || state === 1 || state === 3) {
                          // Clear existing video update timers
                          if (typeof $videoModal.data('video-update-interval') !== 'undefined') {
                            window.clearInterval($videoModal.data('video-update-interval'));
                            $videoModal.removeData('video-update-interval');
                          }

                          $videoModal.data('video-update-interval', window.setInterval(youtubeUpdateHandler, 500));

                          $videoModal.find('.play_btn').addClass('active');
                        }
                        // Paused
                        else if (state === 2) {
                          // Clear existing video update timers
                          if (typeof $videoModal.data('video-update-interval') !== 'undefined') {
                            window.clearInterval($videoModal.data('video-update-interval'));
                            $videoModal.removeData('video-update-interval');
                          }

                          $videoModal.find('.play_btn').removeClass('active');
                        }
                        // Ended
                        else if (state === 0) {
                          $videoModal.find('.close_btn').trigger('click');
                        }
                      }
                    }
                  });

                  $videoModal.data('player', youtubePlayer);

                  break;

                case 'content':
                  $target = $(content);

                  if ($target.length === 0) {
                    return;
                  }

                  $target.addClass('active');
                  break;
              }
            });

            // Video play button click
            $videoModal.find('.play_btn').on('click', function (e) {
              // LOGIC
              var player = $videoModal.data('player');

              e.preventDefault();

              if (typeof player === 'undefined') {
                return;
              }

              // Clear existing video update timers
              if (typeof $videoModal.data('video-update-interval') !== 'undefined') {
                window.clearInterval($videoModal.data('video-update-interval'));
                $videoModal.removeData('video-update-interval');
              }

              $videoModal.data('video-update-interval', window.setInterval(youtubeUpdateHandler, 500));

              if ($(this).hasClass('active')) {
                player.pauseVideo();
              } else {
                player.playVideo();
              }
            });

            // Video scrubber click
            $videoModal.find('.scrubber').on('click', function (e) {
              // DOM
              var $this = $(this);
              // LOGIC
              var player = $videoModal.data('player');
              var position = e.clientX - $this.offset().left;
              var duration;
              var progress = position / $this.width();

              e.preventDefault();

              $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');

              if (typeof player !== 'undefined') {
                duration = player.getDuration();
                player.seekTo(duration * progress);
              }
            });

            // Video fullscreen click
            $videoModal.find('.full_btn').on('click', function (e) {
              // DOM
              var $player;
              // LOGIC
              var player = $videoModal.data('player');
              var requestFullScreen;

              e.preventDefault();

              // Must have an available player to do stuff
              if (typeof player === 'undefined') {
                return;
              }

              $player = $videoModal.find('iframe');
              requestFullScreen = $player[0].requestFullScreen || $player[0].mozRequestFullScreen || $player[0].webkitRequestFullScreen;

              if ($player.length === 0) {
                return;
              }

              requestFullScreen.call($player[0]);
            });

            // Video close button click
            $videoModal.find('.close_btn').on('click', function (e) {
              // LOGIC
              var player = $videoModal.data('player');

              e.preventDefault();
              e.stopPropagation();

              // Clear existing video update timers
              if (typeof $videoModal.data('video-update-interval') !== 'undefined') {
                window.clearInterval($videoModal.data('video-update-interval'));
                $videoModal.removeData('video-update-interval');
              }

              if (typeof player !== 'undefined') {
                player.destroy();
                $videoModal.removeData('player');
              }

              $videoModal.removeClass('active');
              $videoModal.find('.play_btn').removeClass('active');
              $videoModal.find('.scrubber .inner_scrubber').removeAttr('style');
            });

            // Mobile video close button
            $boutique.find('.mobile-video_container .close_btn').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $parent = $this.closest('a');
              var $videoTarget = $parent.find('.mobile-video-target');
              // LOGIC
              var player = $parent.data('player');

              e.preventDefault();
              e.stopPropagation();

              // Must have a player for this functionality to work
              if (typeof player === 'undefined') {
                return;
              }

              player.pauseVideo();
              TweenMax.to([$videoTarget, $this], 1, {
                opacity: 0,
                display: 'none'
              });
            });

            $boutique.find('.modal_container').find('.close_btn').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $parent = $this.closest('.modal_container');

              e.preventDefault();

              $parent.removeClass('active');
            });

            $tiles.not('.has-carousel').add($boutique.find('.slide'))
              .on('mousemove', function (e) {
                // DOM
                var $this = $(this);
                var $canvas = $this.find('canvas');

                // Particle functionality should not work in touch environments and older IE versions
                if (isMobile || isIpad || (ieVersion !== -1 && ieVersion <= 9)) {
                  return;
                }

                if ($canvas.length !== 0) {
                  spawnParticle($canvas, e.pageX - $canvas.offset().left, e.pageY - $canvas.offset().top, 5);
                }
              })
              .on('mouseenter touchstart', function () {
                // DOM
                var $this = $(this);
                var $canvas = $this.find('canvas');
                var $hover = $this.find('.holiday-product_rollover');
                // LOGIC
                var animation = new TimelineMax({
                  onComplete: function () {
                    $this.addClass('revealed');
                  }
                });

                if (isMobile) {
                  return;
                }

                // Hide hoverstates for other tiles
                $tiles.not('.has-carousel').add($boutique.find('.slide')).not($this).trigger('mouseleave');

                animation
                  .fromTo($canvas, 0.5, { backgroundColor: 'rgba(0,0,0,0)' }, { backgroundColor: 'rgba(0,0,0,0.5)' });

                // Rollovers with subheaders skip
                if ($hover.find('.subheader').length !== 0) {
                  animation
                    .set($hover, { opacity: 1 }, '0')
                    .fromTo($hover.find('.subheader'), 0.5, {
                      opacity: 0,
                      display: 'none'
                    }, {
                      opacity: 1,
                      display: 'block'
                    }, '0');
                } else {
                  animation
                    .fromTo($hover, 0.5, { opacity: 0 }, { opacity: 1 }, '0');
                }
              })
              .on('mouseleave', function () {
                // DOM
                var $this = $(this);
                var $canvas = $this.find('canvas');
                var $hover = $this.find('.holiday-product_rollover');
                // LOGIC
                var animation = new TimelineMax({
                  onComplete: function () {
                    $this.removeClass('revealed');
                  }
                });

                if (isMobile) {
                  return;
                }

                animation
                  .to($canvas, 0.5, { backgroundColor: 'rgba(0,0,0,0)' });

                // Rollovers with subheaders skip the
                if ($hover.find('.subheader').length !== 0) {
                  animation
                    .set($hover, { opacity: 1 }, '0')
                    .to($hover.find('.subheader'), 0.5, { opacity: 0 }, '0');
                } else {
                  animation
                    .to($hover, 0.5, { opacity: 0 }, '0');
                }
              });
          }
          // END: EVENTS
        })();
        // END: Tile Handling

        // BEGIN: Tile 1 Functionality
        (function () {
          // DOM
          var $self = $('#holiday-2017_tile-1');
          var $hover = $self.find('.holiday-product_rollover');
          var $skirt = $self.find('.skirt-container svg');
          var $dots = $self.find('.skirt-container .dots');
          // LOGIC
          var animation = new TimelineMax({
            paused: true,
            onComplete: function () {
            // LOGIC
              animation = new TimelineMax({ paused: true });

              animation
                .staggerFromTo($dots, 0.4, { opacity: 0 }, {
                  opacity: 1,
                  repeat: 1,
                  yoyo: true,
                  immediateRender: false
                }, 0.3)
                .staggerFromTo($dots, 0.4, { opacity: 0 }, {
                  opacity: 1,
                  repeat: 1,
                  yoyo: true,
                  immediateRender: false
                }, 0.3, '-=0.2');
              $self.find('.skirt-container').on('mouseenter touchstart', function () {
                if (isMobile) {
                  return;
                }

                if (!$self.hasClass('ready') || animation.isActive()) {
                  return;
                }

                animation.play(0);
              });
            }
          });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          {
            $hover.css({
              display: 'block',
              opacity: 1
            });

            animation
              .fromTo($skirt, 1, { opacity: 0 }, {
                opacity: 1,
                ease: Expo.easeOut
              })
              .fromTo($skirt.find('circle'), 0.5, { scaleX: '0' }, {
                scaleX: '1',
                ease: Expo.easeOut
              }, '0')
              .fromTo($skirt.find('circle'), 1, { scaleY: '0' }, {
                scaleY: '1',
                ease: Expo.easeOut
              }, '0')
              .staggerFromTo($dots, 0.4, { opacity: 0 }, {
                opacity: 1,
                repeat: 1,
                yoyo: true,
                immediateRender: false
              }, 0.3, '-=0.5')
              .staggerFromTo($dots, 0.4, { opacity: 0 }, {
                opacity: 1,
                repeat: 1,
                yoyo: true,
                immediateRender: false
              }, 0.3, '-=0.2');
          }
          // END: Init

          // BEGIN: Events
          {
            $self.off('mousemove mouseenter mouseleave touchstart');

            $window.on('postLoad', function () {
              if (isMobile) {
                return;
              }

              animation.play();
            });

            $self.find('.play-button').on('click', function (e) {
              e.preventDefault();

              $self.find('.holiday-image > a').trigger('click', true);
            });
          }
          // END: Events
        })();
        // END: Tile 1 Functionality
      })();
      // END: Holiday 2017 Landing

      // BEGIN: Get The Look
      (function () {
        // DOM
        var $carousels;
        var $deeplinkTarget;
        // LOGIC
        var autoScrollTimeout;
        var deeplinkData = deeplinkHelper.get();
        var resizeTimeout;
        var controller = new ScrollMagic.Controller();

        if (!$boutique.hasClass('get-the-look')) {
          return;
        }

        // BEGIN: INIT
        {
          $carousels = $boutique.find('.carousel');
          $carousels.el_carousel({
            debug: debug,
            increment: $boutique.hasClass('mobile') ? '100%' : '200%',
            useGSAP: true,
            duration: 1,
            callbackAnimationOptions: {
              useClones: false
            }
          });

          // Desktop functionality
          if (isDesktop) {
            // Set up autoscroll after a set time
            autoScrollTimeout = window.setTimeout(function () {
              TweenMax.to($window, 1, {
                scrollTo: { y: $carousels.offset().top }
              });
            }, 5000);
          }

          // Handle Deeplinking
          if (deeplinkData.length >= 1) {
            switch (parseInt(deeplinkData[0])) {
              case 1:
                $deeplinkTarget = $('body');
                break;

              case 2:
                if (isMobile) {
                  $deeplinkTarget = $boutique.find('.details-carousel').first();
                } else {
                  $deeplinkTarget = $boutique.find('.get-the-look_carousels');
                }
                break;
            }
          }

          // Init ELProducts
          $carousels.elproduct({
            'target': '.el-product',
            'products': '.el-product_id-list',
            'debug': false,
            onSuccess: function () {
              var $elProducts = $carousels.find('.el-product');

              // Look for formattedUnitPrice per .el-product
              $elProducts.each(function () {
                // DOM
                var $this = $(this);
                var $price = $this.find('.el-product_price');
                // LOGIC
                var useML = $this.data('use-ml');
                var productData = $this.data('full_product_json');
                var skuData;
                var unitPrice;
                var price;
                var measurement;

                if (typeof useML === 'undefined') {
                  return;
                }

                // Attempt to find and use 'formattedUnitPrice' field if available
                if (typeof productData !== 'undefined' && typeof productData.skus !== 'undefined' && productData.skus.length !== 0) {
                  skuData = productData.skus[0];
                  unitPrice = skuData.formattedUnitPrice;
                  price = skuData.formattedPrice;
                  measurement = skuData.PRODUCT_SIZE;

                  // Must have all fields to replace price
                  if (typeof unitPrice === 'string' && unitPrice.trim().length !== 0 && typeof price === 'string' && price.trim().length !== 0 && typeof measurement === 'string' && measurement.trim().length !== 0) {
                    $price.html('<span class="size">' + measurement + '</span> <span class="price">' + price + '</span><br /><span ="unit-price">' + unitPrice + '</span>');
                  }
                }
              });

              // Set up click events
              $elProducts.find('.el-product_shop-now').addBack().on('click', function (e) {
                // DOM
                var $this = $(this);
                // LOGIC
                var productData = $this.closest('.el-product').data('full_product_json');

                if (typeof productData === 'undefined') {
                  return;
                }

                if ($this.hasClass('add-to-bag')) {
                  e.preventDefault();

                  site.addToCart({
                    skuData: {
                      SKU_BASE_ID: productData.skus[0].SKU_ID.replace(/[A-z]+/, ''),
                      PARENT_CAT_ID: productData.PRODUCT_ID
                    },
                    quantity: 1,
                    QTY: 1
                  });
                } else if ($this.hasClass('quickshop')) {
                  e.preventDefault();

                  site.quickshop(productData);
                }
              });
            }
          });

          // Hide containers for future animation
          if (isMobile) {
            controller.enabled(false);

            // Init scroll magic scenes
            $boutique.find('.carousel_container.details-carousel').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var scene;

              scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 'onCenter',
                duration: function () {
                  return $this.height();
                }
              });

              scene
                .addTo(controller)
                .on('enter', function () {
                  $this.addClass('visible');
                  $this.trigger('gainedVisible');
                })
                .on('leave', function () {
                  $this.removeClass('visible');
                  $this.trigger('lostVisible');
                });
            });
          } else {
            $carousels.find('.description-container').css({ width: 0 });
          }
        }
        // END: INIT

        // BEGIN: EVENTS
        {
          // Kill inactivity timeout on scroll/click activity
          $window.on('postLoad', function () {
            // DOM
            var $pageHeader = $('.page-header');

            if (typeof $deeplinkTarget !== 'undefined' && $deeplinkTarget.length !== 0) {
              TweenMax.to($window, 0.5, {
                scrollTo: {
                  y: $deeplinkTarget.offset().top - ($pageHeader.length !== 0 ? $pageHeader.height() : 0),
                  autoKill: false
                }
              });
            }

            $window.trigger('canvasUpdate');

            if (typeof controller !== 'undefined') {
              controller.enabled(true).update(true);
            }
          }).on('scroll click', function () {
            window.clearTimeout(autoScrollTimeout);
          })
          // Throttle resize
            .on('resize', function () {
              if (isMobile) {
                return;
              }

              if (typeof resizeTimeout !== 'undefined') {
                window.clearTimeout(resizeTimeout);
              }

              resizeTimeout = window.setTimeout(function () {
                TweenMax.set($carousels.find('.description-container'), { height: $boutique.find('.get-the-look_carousels').height() });
                TweenMax.set($carousels.find('.description-content'), {
                  width: $carousels.first().find('.col.right').first().width(),
                  padding: '0 0 0 ' + $carousels.first().find('.col.right').first().width() * 0.1 + 'px'
                });
              }, 500);
            });

          // Basic carousel progression
          $boutique.find('.arrow').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $carousel = $this.closest('.carousel_container');

            e.preventDefault();

            if (!$(e.target).is('img')) {
              return;
            }

            if (isMobile) {
              if ($carousel.hasClass('eye-looks-selector') || $carousel.hasClass('eye-looks')) {
                $carousel = $boutique.find('.eye-looks-selector .carousel, .eye-looks .carousel');
              } else if ($carousel.hasClass('lip-looks-selector') || $carousel.hasClass('lip-looks')) {
                $carousel = $boutique.find('.lip-looks-selector .carousel, .lip-looks .carousel');
              }
            } else {
              $carousel = $carousel.find('.carousel');
            }

            if ($this.hasClass('right') && $carousel.length !== 0) {
              $carousel.carouselNext();
            } else if ($this.hasClass('left') && $carousel.length !== 0) {
              $carousel.carouselPrev();
            }
          });

          // Mark clicked model as active, scroll and display related product
          $boutique.find('.get-the-look_header .col').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $aTag = $this.find('a');
            // LOGIC
            var index = $this.index();

            if (isMobile) {
              return;
            }

            e.preventDefault();

            if ($this.hasClass('active')) {
              $aTag.removeClass('active');
              $boutique.find('header').removeClass('active');
            } else {
              $aTag.addClass('active');
              $this.siblings().find('a').removeClass('active');
              $boutique.find('header').addClass('active');

              TweenMax.to($window, 0.5, {
                scrollTo: {
                  y: $boutique.find('.header-text-main').length !== 0 ? $boutique.find('.header-text-main').offset().top : $carousels.offset().top,
                  autoKill: false
                }
              });

              $carousels.elCarouselTo(index);
            }
          });

          // Close all "Get the look" containers on slide progression
          $carousels.children().on('slideWillLoseActive', function () {
            $(this).find('.close_btn').trigger('click');
            $carousels.find('.description-container').trigger('close');
          });

          // Mobile only, triggers overlay image fade out in the details carousels
          $boutique.find('.details-carousel')
            .on('gainedVisible', function () {
              // DOM
              var $this = $(this);
              var $activeSlide = $this.find('.active');

              if (!isMobile) {
                return;
              }

              $activeSlide.trigger('slideHasGainedActive');
            });

          // Mobile only, Fades out the overlay images in the details
          $boutique.find('.details-carousel .carousel').children()
            .on('slideHasLostActive', function () {
              // DOM
              var $this = $(this);
              var $overlayImage = $this.find('.overlay-image');

              // Mobile only, must have an overlay image
              if (!isMobile || $overlayImage.length === 0) {
                return;
              }

              TweenMax.to($overlayImage, 0.5, {
                opacity: 1,
                delay: 0.8
              });
            })
            // Brings back the overlay images in the details
            .on('slideHasGainedActive', function () {
              // DOM
              var $this = $(this);
              var $overlayImage = $this.find('.overlay-image');

              // Mobile only, must have an overlay image, and must be visible via ScrollMagic
              if (!isMobile || $overlayImage.length === 0 || !$this.closest('.details-carousel').hasClass('visible')) {
                return;
              }

              TweenMax.to($overlayImage, 0.5, {
                opacity: 0,
                delay: 0.8
              });
            });

          // Display respective "Get the look"
          $carousels.find('.get-the-look_button').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $getTheLook = $this.closest('.slide').find('.description-container');
            var $carouselContainer = $this.closest('.carousel_container');
            // LOGIC
            var animation = new TimelineMax();

            e.preventDefault();

            if ($carouselContainer.hasClass('get-the-look_active')) {
              $getTheLook.removeClass('active');
              $carouselContainer.removeClass('get-the-look_active');
            } else {
              $getTheLook.addClass('active');
              $carouselContainer.addClass('get-the-look_active');

              if (isMobile) {
                TweenMax.to($window, 0.5, {
                  scrollTo: {
                    y: $this.parent().offset().top,
                    autoKill: false
                  }
                });
              } else {
                animation.set($getTheLook.find('.description-content'), {
                  width: $carousels.first().find('.col.right').first().width(),
                  padding: '0 0 0 ' + $carousels.first().find('.col.right').first().width() * 0.1 + 'px'
                });
                animation.fromTo($getTheLook, 1, {
                  width: 0,
                  opacity: 0
                }, {
                  width: '100%',
                  opacity: 1
                });
              }
            }
          });

          // Hide "Get the look"
          $carousels.find('.description-container').on('click close', function (e) {
            // DOM
            var $this = $(this);
            var $carouselContainer = $this.closest('.carousel_container');

            e.preventDefault();

            if ($(e.target).closest('.close_btn').length !== 0 || e.type === 'close') {
              // Description container must be active to warrant 'closing'
              if (!$this.hasClass('active')) {
                return;
              }

              if (isMobile) {
                $this.removeClass('active');
                $carouselContainer.removeClass('get-the-look_active');
              } else {
                TweenMax.set($this.find('.description-content'), {
                  width: $carousels.first().find('.col.right').first().width(),
                  padding: '0 0 0 ' + $carousels.first().find('.col.right').first().width() * 0.1 + 'px'
                });
                TweenMax.fromTo($this, 1, {
                  width: '100%',
                  opacity: 1
                }, {
                  width: 0,
                  opacity: 0,
                  onComplete: function () {
                    $this.removeClass('active');
                    $carouselContainer.removeClass('get-the-look_active');
                  }
                });
              }
            }
          });

          // Mobile only carousel click functionality
          $carousels.on('click', function (e) {
            // DOM
            var $this = $(this);
            var $parent = $this.closest('.carousel_container');
            var $target;
            var $targetCarousel;
            var $pageHeader = $('.page-header');
            // LOGIC
            var activeSlideIndex = $this.find('.slide.active').index();

            e.preventDefault();

            if (!isMobile) {
              return;
            }

            if ($parent.hasClass('eye-looks-selector')) {
              $target = $boutique.find('.eye-looks');
              $targetCarousel = $target.find('.carousel');

              activeSlideIndex = $($this.data('elCarousel').slides[0]).index();
              $targetCarousel.carouselTo(activeSlideIndex);

              TweenMax.to($window, 0.5, {
                scrollTo: {
                  y: $targetCarousel.offset().top - ($pageHeader.length !== 0 ? $pageHeader.height() : 0),
                  autoKill: false
                }
              });
            } else if ($parent.hasClass('lip-looks-selector')) {
              $target = $boutique.find('.lip-looks');
              $targetCarousel = $target.find('.carousel');

              activeSlideIndex = $($this.data('elCarousel').slides[0]).index();
              $targetCarousel.carouselTo(activeSlideIndex);

              TweenMax.to($window, 0.5, {
                scrollTo: {
                  y: $targetCarousel.offset().top - ($pageHeader.length !== 0 ? $pageHeader.height() : 0),
                  autoKill: false
                }
              });
            }
          }).swipe({
            swipeLeft: function () {
              // DOM
              var $this = $(this);
              var $carousel = $this.closest('.carousel_container');

              if (!isMobile && !isIpad) {
                return;
              }

              if ($carousel.hasClass('eye-looks-selector') || $carousel.hasClass('eye-looks')) {
                $carousel = $boutique.find('.eye-looks-selector .carousel, .eye-looks .carousel');
              } else if ($carousel.hasClass('lip-looks-selector') || $carousel.hasClass('lip-looks')) {
                $carousel = $boutique.find('.lip-looks-selector .carousel, .lip-looks .carousel');
              }

              $carousel.carouselNext();
            },
            swipeRight: function () {
              // DOM
              var $this = $(this);
              var $carousel = $this.closest('.carousel_container');

              if (!isMobile && !isIpad) {
                return;
              }

              if ($carousel.hasClass('eye-looks-selector') || $carousel.hasClass('eye-looks')) {
                $carousel = $boutique.find('.eye-looks-selector .carousel, .eye-looks .carousel');
              } else if ($carousel.hasClass('lip-looks-selector') || $carousel.hasClass('lip-looks')) {
                $carousel = $boutique.find('.lip-looks-selector .carousel, .lip-looks .carousel');
              }

              $carousel.carouselPrev();
            },
            excludedElements: 'button, input, select, textarea, .noSwipe',
            preventDefaultEvents: false
          });

          $('.el-product .el-product_shop-now-container').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $elProduct = $this.closest('.el-product');
            // LOGIC
            var data = $elProduct.data('json_product_full');

            e.preventDefault();

            if (typeof data === 'undefined') {
              return;
            }
          });
        }
        // END: EVENTS
      })();
      // END: Get The Look

      // BEGIN: General
      (function () {
        // DOM
        var $navMenuContainer = $boutique.find('.holiday-2017_side-nav-wrapper');
        var $navMenuAnimationMain = $navMenuContainer.find('.holiday-2017_side-nav');
        var $navMenuAnimationSub = $navMenuContainer.find('.holiday-2017-primary_nav');

        if (!isMobile && $boutique.hasClass('animate')) {
          $navMenuContainer.find('.holiday-2017-primary_nav .button_shop').on('click', function (e) {
            // LOGIC
            var animation = new TimelineMax();

            e.preventDefault();

            if (!$navMenuContainer.hasClass('open')) {
              animation
                .to($navMenuAnimationSub, 0.5, {
                  x: '-100%',
                  opacity: 0,
                  display: 'block'
                })
                .to($navMenuAnimationMain, 0.5, {
                  x: '0%',
                  opacity: 1,
                  display: 'block'
                });

              $navMenuContainer.addClass('open');
            }
          });

          $navMenuContainer.find('.secondary_nav-animate_close').on('click', function (e) {
            // LOGIC
            var animation = new TimelineMax({
              onComplete: function () {
                $navMenuContainer.removeClass('open');
              }
            });

            e.preventDefault();

            if ($navMenuContainer.hasClass('open')) {
              animation
                .to($navMenuAnimationMain, 0.5, {
                  x: '-100%',
                  opacity: 0,
                  display: 'block',
                  clearProps: 'all'
                })
                .to($navMenuAnimationSub, 0.5, {
                  x: '0%',
                  opacity: 1,
                  display: 'block',
                  clearProps: 'all'
                });
            }
          });
        } else {
          // BEGIN: Mobile Menu Functionality
          (function () {
            // DOM
            var $menuTrigger = $boutique.find('.holiday-2017-primary_nav .button_shop');
            var $menu = $boutique.find('.holiday-2017_side-nav');

            // BEGIN: EVENTS
            {
              $menuTrigger.on('click', function (e) {
                var animation;

                // Mobile only functionality
                if (!isMobile) {
                  return;
                }

                e.preventDefault();

                animation = new TimelineMax();

                if (!$menu.hasClass('active')) {
                  animation
                    .to($menuTrigger.find('.arrow'), 0.5, { rotation: '90deg' })
                    .to($menu, 0.5, {
                      y: '0%',
                      className: '+=active'
                    }, '0');
                } else {
                  animation
                    .to($menuTrigger.find('.arrow'), 0.5, { rotation: '0deg' })
                    .to($menu, 0.5, {
                      y: '-100%',
                      className: '-=active'
                    }, '0');
                }
              });
            }
            // END: EVENTS
          })();
          // END: Mobile Menu Functionality
        }

        // BEGIN: Hero Social Share
        // Should update with each article, not done by mustache
        $boutique.find('.button_twitter a')
          .on('click', function (e) {
            // DOM
            var $this = $(this);

            e.preventDefault();

            window.open(
              $this.attr('href'),
              '_blank',
              'height=450, width=550, top=' + (window.clientWidth / 2 - 275) + ',left=' + (window.clientHeight / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
            );
          });

        $boutique.find('.button_facebook a')
          .on('click', function (e) {
            // DOM
            var $this = $(this);

            e.preventDefault();

            window.open(
              $this.attr('href'),
              '_blank',
              'height=450, width=550, top=' + (window.clientWidth / 2 - 275) + ',left=' + (window.clientHeight / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
            );
          });
      })();
      // END: General

      // BEGIN: Preloader
      (function () {
        var $loader = $('#loader');
        var spinnerOptions = {
          lines: 17, // The number of lines to draw
          length: 0, // The length of each line
          width: 5, // The line thickness
          radius: 26, // The radius of the inner circle
          scale: 1, // Scales overall size of the spinner
          corners: 1, // Corner roundness (0..1)
          color: '#c11b04', // #rgb or #rrggbb or array of colors
          opacity: 0.5, // Opacity of the lines
          rotate: 0, // The rotation offset
          direction: 1, // 1: clockwise, -1: counterclockwise
          speed: 1, // Rounds per second
          trail: 30, // Afterglow percentage
          zIndex: 2e9, // The z-index (defaults to 2000000000)
          className: 'spinner', // The CSS class to assign to the spinner
          top: '50%', // Top position relative to parent
          left: '50%', // Left position relative to parent
          shadow: false, // Whether to render a shadow
          hwaccel: true, // Whether to use hardware acceleration
          position: 'absolute' // Element positioning
        };
        var spinner = new Spinner(spinnerOptions).spin($loader[0]);

        // BEGIN: Init
        {
          $boutique.find('img').FreeLoader({
            callback: function () {
              // Use webapi to force animation to end of queue
              window.setTimeout(function () {
                TweenMax.to($loader, 1, {
                  opacity: 0,
                  display: 'none',
                  onComplete: function () {
                    spinner.stop();
                    $window.trigger('postLoad');
                  }
                });
              }, 0);
            }
          });
        }
        // END: Init
      })();
      // END: Preloader

      // BEGIN: Youtube
      (function () {
        // LOGIC
        var tag = document.createElement('script');
        var firstScriptTag;

        // Listen for Youtube API Load
        window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
          youtubeAPIReady = true;

          $window.trigger('youtubeReady');
        };

        tag.src = 'https://www.youtube.com/iframe_api';
        firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      })();
      // END: Youtube
    }
  };
})(jQuery);
